import { createSelector } from '@ngrx/store';

import { getPaymentState } from '../getPaymentState';

export const isPayingWithApplePay = createSelector(
    getPaymentState,
    (paymentState) => paymentState.paymentMethod?.vendorService === OLO.Enums.PAYMENT_VENDOR_SERVICE.APPLE_PAY
        && Boolean(paymentState.paymentMethod.applePaymentData)
);
